import { bl_fi_mst_item_entity_pricing_import_file_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';


export class FinancialItemEntityPriceListingImportFileHdrContainer extends BaseContainerModel {
  bl_fi_mst_item_entity_pricing_import_file_hdr: bl_fi_mst_item_entity_pricing_import_file_hdr_RowClass = new bl_fi_mst_item_entity_pricing_import_file_hdr_RowClass();
}
